import React from 'react';
import { Button } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router';
import { useTranslations } from '../contexts/translation.context';

interface LogoutButtonProps {
  variant?: 'flat' | 'bordered' | 'solid' | 'light' | 'faded' | 'shadow' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullWidth?: boolean;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({
  variant = 'flat',
  size = 'md',
  className = '',
  fullWidth = false
}) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslations();

  const handleLogout = () => {
    logout();

    // Redirect to appropriate login page based on user role
    const loginPath = user?.role === 'partner' ? '/partner/sign-in' : '/sign-in';
    navigate(loginPath, { replace: true });
  };

  return (
    <Button
      color="danger"
      variant={variant}
      size={size}
      className={className}
      fullWidth={fullWidth}
      startContent={<Icon icon="mdi:logout" />}
      onClick={handleLogout}
    >
      {t('sidebar.logout')}
    </Button>
  );
}; 